/**
 * Centralized environment configuration.
 * Reads from Vite's import.meta.env and provides typed, validated access.
 * All environment-dependent values should be accessed through this module.
 */

const environment = Object.freeze({
  // Moneris iframe URL and origin — set per environment via .env / .env.production
  monerisIframeUrl: import.meta.env.MONERIS_IFRAME_URL || 'https://esqa.moneris.com/HPPtoken/index.php',
  monerisOrigin: import.meta.env.MONERIS_ORIGIN || 'https://esqa.moneris.com',

  // Backend API
  paymentApiUrl: import.meta.env.PAYMENT_API_URL || '',
});

export default environment;
